import { Component } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-pin-management',
  templateUrl: './pin-management.component.html',
  styleUrl: './pin-management.component.css'
})
export class PinManagementComponent {

  showModal = false;
  fieldName = '';
  fieldType = 'input';
  customFields: any[] = [];
  loading = false;

  get currentUser(): any {
    return JSON.parse(localStorage.getItem('user') || '{}');
  }

  constructor(
    private data: DataserviceService,
    private nzNotify: NzNotificationService
  ) { }

  ngOnInit(): void {
    this.getCustomFields();
  }

  getCustomFields() {
    this.loading = true;
    this.data.getData('pin-management/fields-by-company/' + this.currentUser.company_id).subscribe({
      next: (res: any) => {
        this.customFields = res?.data ?? [];
        this.loading = false;
      },
      error: (err) => {
        this.nzNotify.error('Error', err?.message || 'Error getting custom fields');
        this.loading = false;
      }
    });
  }

  addCustomField() {
    this.fieldName = '';
    this.fieldType = 'input';
    this.showModal = true;
  }

  saveField() {
    const payload = {
      company_id: this.currentUser.company_id,
      custom_field: { name: this.fieldName, type: this.fieldType },
      status: 'visible'
    };
    this.data.postData(payload, 'pin-management/add-field').subscribe({
      next: (res: any) => {
        if (res?.result === 'error') {
          this.nzNotify.error('Error', res?.message || 'Failed to add field');
          return;
        }
        this.nzNotify.success('Success', 'Custom field added');
        this.showModal = false;
        this.getCustomFields();
      },
      error: (err) => {
        this.nzNotify.error('Error', err?.message || 'Error adding custom field');
      }
    });
  }

  toggle(field: any) {
    const newStatus = field.status === 'visible' ? 'hidden' : 'visible';
    this.data.postData({ id: field.id, status: newStatus }, 'pin-management/update-field').subscribe({
      next: (res: any) => {
        if (res?.result === 'error') {
          this.nzNotify.error('Error', res?.message || 'Failed to update');
          return;
        }
        this.nzNotify.success('Success', 'Field updated');
        this.getCustomFields();
      },
      error: (err) => {
        this.nzNotify.error('Error', err?.message || 'Error updating field');
      }
    });
  }
}